import React from "react"
import { Navigate } from "react-router-dom"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

// Dashboard
import Dashboard from "../pages/Dashboard/index"
import Configs from "../config"
import VerifyCode from "pages/Authentication/VerifyOTP"
import ResetPassword from "pages/Authentication/ResetPassword"
import StaffIndex from "pages/Staff"
import RolesIndex from "pages/Roles"
import ProjectIndex from "pages/Projects"
import DocumentPage from "pages/Projects/documentPage"
import DocumentView from "pages/Projects/documentView"

// ── NEW: Customers & Document Types modules ──────────────────────────────────
import CustomerIndex from "pages/Customers"
import CustomerView from "pages/Customers/CustomerView"
import DocumentsIndex from "pages/Documents"
import CategoryIndex from "pages/Category"
import AuditLogs from "pages/AuditLogs/AuditLogs"
import QueriesIndex from "pages/Queries"
import NotificationsPage from "pages/Notifications"
// ─────────────────────────────────────────────────────────────────────────────

const authProtectedRoutes = [
  { path: `${Configs.appurl}dashboard`, component: <Dashboard /> },

  // Staff Module
  { path: `${Configs.appurl}staff`, component: <StaffIndex /> },

  // Roles Module
  { path: `${Configs.appurl}roles`, component: <RolesIndex /> },

  // Projects Module
  { path: `${Configs.appurl}projects`, component: <ProjectIndex /> },
  {
    path: `${Configs.appurl}projects/documents/:id`,
    component: <DocumentPage />,
  },
  {
    path: `${Configs.appurl}projects/documents/view/:id`,
    component: <DocumentView />,
  },

  // ── NEW: Customers Module ────────────────────────────────────────────────
  { path: `${Configs.appurl}customers`, component: <CustomerIndex /> },
  { path: `${Configs.appurl}customers/:id`, component: <CustomerView /> },

  // ── NEW: Document Types Module ───────────────────────────────────────────
  { path: `${Configs.appurl}document-types`, component: <DocumentsIndex /> },

  // ── NEW: Categories Module ───────────────────────────────────────────────
  { path: `${Configs.appurl}categories`, component: <CategoryIndex /> },

  // ── NEW: Queries Module ──────────────────────────────────────────────────
  { path: `${Configs.appurl}queries`, component: <QueriesIndex /> },

  // ── NEW: Audit Logs ───────────────────────────────────────────
  { path: `${Configs.appurl}audit-logs`, component: <AuditLogs /> },

  // ── NEW: Notifications ────────────────────────────────────────
  { path: `${Configs.appurl}notifications`, component: <NotificationsPage /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: `${Configs.appurl}`,
    exact: true,
    component: <Navigate to="dashboard" />,
  },
]

const publicRoutes = [
  { path: `${Configs.appurl}logout`, component: <Logout /> },
  { path: `${Configs.appurl}login`, component: <Login /> },
  { path: `${Configs.appurl}forgot-password`, component: <ForgetPwd /> },
  { path: `${Configs.appurl}verify-code`, component: <VerifyCode /> },
  { path: `${Configs.appurl}reset-password`, component: <ResetPassword /> },
]

export { authProtectedRoutes, publicRoutes }
